module.exports = __webpack_public_path__ + "img/lisence1.493744ff.png";